<template>
    <el-container class="home-container">
        <el-header>
            <div>
                <img src="@/assets/img/logo.png" alt="" class="uimg" />
                <span class="nametitle">百姓运动码管理系统</span>
                <div class="rightfile">
                    <el-dropdown class="rightfile">
                        <div class="box">
                            <el-avatar icon="el-icon-user-solid" :src="userface" style="font-size: 30px; width: 44px; height: 44px"></el-avatar>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <div @click="routewodezhanghao">
                                    <i class="el-icon-user-solid"></i>
                                    我的账号
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="user_type === 0">
                                <div @click="routeWeb">
                                    <i class="el-icon-user-solid"></i>
                                    硬件后台
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <div @click="loginOut">
                                    <i class="el-icon-switch-button"></i>
                                    退出登录
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <div class="size">
                        {{ username }}
                    </div>
                </div>
            </div>
        </el-header>
        <el-container>
            <el-aside>
                <el-menu background-color="#333744" text-color="#fff" active-text-color="#409EFF" unique-opened :collapse-transition="false" router :default-active="$route.path">
                    <el-menu-item index="/shouye">
                        <i class="el-icon-s-home"></i>
                        <span slot="title">首页</span>
                    </el-menu-item>
                    <!--           一级菜单-->
                    <div v-for="item in menuList" :key="item.id">
                        <el-menu-item v-if="item.url" :index="'/' + item.url">
                            <i v-if="item.icon" :class="item.icon"></i>
                            <span slot="title">{{ item.name }}</span>
                        </el-menu-item>
                        <el-submenu v-else :index="item.id + ''">
                            <!-- 一级菜单的模板区域 -->
                            <template slot="title">
                                <!-- 图标 -->
                                <i :class="item.icon"></i>
                                <!-- 文本 -->
                                <span>{{ item.name }}</span>
                            </template>
                            <!-- 二级菜单 -->
                            <!--   基础设置  -->
                            <el-menu-item :index="'/' + subItem.url" v-for="subItem in item.sub_menu" :key="subItem.id" @click="saveNavState('/' + subItem.url)">
                                <template slot="title">
                                    <!-- 图标 -->
                                    <i v-if="subItem.icon" :class="subItem.icon"></i>
                                    <!-- 文本 -->
                                    <span>{{ subItem.name }}</span>
                                </template>
                            </el-menu-item>
                        </el-submenu>
                    </div>
                </el-menu>
            </el-aside>
            <!--      <el-aside>-->
            <!--        &lt;!&ndash; 菜单&ndash;&gt;-->
            <!--          <el-menu-item index="/lunbotushezhi">-->
            <!--            <i class="el-icon-picture-outline"></i>-->
            <!--            <span slot="title">轮播图设置</span>-->
            <!--          </el-menu-item>-->
            <!--          <el-submenu index="299">-->
            <!--            <template slot="title">-->
            <!--              <i class="el-icon-office-building" style="margin-right: 10px"></i>-->
            <!--              <span>社团管理</span>-->
            <!--            </template>-->
            <!--            <el-menu-item index="/ruzhushenqing">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">入驻申请</span>-->
            <!--            </el-menu-item>-->
            <!--            <el-menu-item index="/shangxiehuiguanli">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">社团管理</span>-->
            <!--            </el-menu-item>-->
            <!--          </el-submenu>-->
            <!--          <el-submenu index="12656">-->
            <!--            <template slot="title">-->
            <!--              <i class="el-icon-document" style="margin-right: 10px"></i>-->
            <!--              <span>发布管理</span>-->
            <!--            </template>-->
            <!--            <el-menu-item index="/tiezishenhe">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">帖子审核</span>-->
            <!--            </el-menu-item>-->
            <!--            <el-menu-item index="/tieziguanli">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">帖子管理</span>-->
            <!--            </el-menu-item>-->
            <!--            <el-menu-item index="/huodongguanli">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">活动管理</span>-->
            <!--            </el-menu-item>-->
            <!--            <el-menu-item index="/zhengcejiedu">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">活动资讯</span>-->
            <!--            </el-menu-item>-->
            <!--          </el-submenu>-->
            <!--          <el-submenu index="12">-->
            <!--            <template slot="title">-->
            <!--              <i class="el-icon-user" style="margin-right: 10px"></i>-->
            <!--              <span>通讯录管理</span>-->
            <!--            </template>-->
            <!--            <el-menu-item index="/huiyuanguanli">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">会员管理</span>-->
            <!--            </el-menu-item>-->
            <!--            <el-menu-item index="/huiyuanziliaoshenhe">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">资料审核</span>-->
            <!--            </el-menu-item>-->
            <!--            <el-menu-item index="/mingpianguanli">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">名片管理</span>-->
            <!--            </el-menu-item>-->
            <!--          </el-submenu>-->
            <!--          <el-submenu index="293392222">-->
            <!--            <template slot="title">-->
            <!--              <i class="el-icon-warning-outline" style="margin-right: 10px"></i>-->
            <!--              <span>信息管理</span>-->
            <!--            </template>-->
            <!--            <el-menu-item index="/shenfenzhengshenhe">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">身份证审核</span>-->
            <!--            </el-menu-item>-->
            <!--            <el-menu-item index="/jubaoguanli">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">举报管理</span>-->
            <!--            </el-menu-item>-->
            <!--            <el-menu-item index="/yijianfankui">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">意见反馈</span>-->
            <!--            </el-menu-item>-->
            <!--          </el-submenu>-->
            <!--          <el-submenu index="29339">-->
            <!--            <template slot="title">-->
            <!--              <i class="el-icon-money" style="margin-right: 10px"></i>-->
            <!--              <span>交易管理</span>-->
            <!--            </template>-->
            <!--            <el-menu-item index="/tixiandakuan">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">提现打款</span>-->
            <!--            </el-menu-item>-->
            <!--            <el-menu-item index="/xiaofeijilu">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">消费记录</span>-->
            <!--            </el-menu-item>-->
            <!--          </el-submenu>-->
            <!--          <el-submenu index="2933229">-->
            <!--            <template slot="title">-->
            <!--              <i class="el-icon-setting" style="margin-right: 10px"></i>-->
            <!--              <span>系统设置</span>-->
            <!--            </template>-->
            <!--            <el-menu-item index="/duanxinpeizhi">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">短信配置</span>-->
            <!--            </el-menu-item>-->
            <!--            <el-menu-item index="/zhanghaoguanli">-->
            <!--              <i class="el-icon-tickets" style="margin-right: 10px"></i>-->
            <!--              <span slot="title">账号管理</span>-->
            <!--            </el-menu-item>-->
            <!--          </el-submenu>-->
            <!--        </el-menu>-->
            <!--      </el-aside>-->
            <el-main class="box">
                <transition name="breadcrumb">
                    <router-view> </router-view>
                </transition>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import { mapState } from "vuex";
    import { adminInfo, adminLogout } from "@/api/login";
    export default {
        name: "home",
        computed: {
            ...mapState(["rightList"]),
        },
        data() {
            return {
                ims: require("../../assets/img/user.png"),
                userface: "",
                username: "",
                user_type: "",
                menuList: [],
                // 被激活的链接地址
                activePath: "",
            };
        },
        created() {
            this.activePath = window.sessionStorage.getItem("activePath");
            this.ziliaoxiangqing();
            this.menuList = this.rightList;
            console.log(this.$router)
        },
        methods: {
            // 保存链接的激活状态
            saveNavState(activePath, item) {
                window.sessionStorage.setItem("activePath", activePath);
                this.activePath = activePath;
            },
            ziliaoxiangqing() {
                const obj = {
                    token: sessionStorage.getItem("token"),
                };
                adminInfo(obj).then(({ data: res }) => {
                    console.log("_user info res", res);
                    this.userface = res.userface;
                    this.username = res.user_name;
                    this.user_type = res.type;
                    // this.type = res.
                });
            },
            loginOut() {
                this.$confirm("是否确认退出账号 ", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        const obj = {
                            token: sessionStorage.getItem("token"),
                        };

                        adminLogout(obj).then(({ data: res }) => {
                            console.log("res", res);
                            if (res.result === 1) {
                                this.$message({
                                    message: res.msg,
                                    type: "success",
                                    duration: "2000",
                                });
                            }
                            sessionStorage.clear();
                            this.$router.push("/login");
                            window.location.reload();
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消退出",
                        });
                    });
            },
            routewodezhanghao() {
                this.$router.push("/wodezhanghao");
            },
            routeWeb(){
              // window.location.href = "http://wenzhouyijian.zhaohaipan.top:7291/#/user"
              window.open('http://wenzhouyijian.zhaohaipan.top:7291/#/user')
            }
        },
    };
</script>

<style lang='less' scoped>
    body {
        min-width: 1200px;
        overflow-x: scroll;
    }

    .el-main {
        background: #fbfbfb;
    }
    .box{
        // padding: 0;
    }

    .el-container {
        height: 100%;
    }

    .el-header {
        position: relative;
        //background: url("../../assets/image/bg.jpg");
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 0;
        align-items: center;
        height: 60px;
        opacity: 1;
        background: #ffffff;
        box-shadow: 0px 3px 6px 0px rgba(220, 220, 220, 0.3);
        border-bottom: 1px solid #ffffff;

        .nametitle {
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: left;
            color: #2e2e2e;
            letter-spacing: 0px;
        }

        .uimg {
            margin-left: 22px;
            width: 34px;
            height: 34px;
            opacity: 1;
        }

        div {
            display: flex;
            align-items: center;

            img {
                margin: 5px 5px 5px 20px;
                width: 40px;
                height: 40px;
            }

            span {
                margin-left: 14px;
            }
        }

        .rightfile:hover {
            opacity: 0.8;
        }

        .rightfile {
            position: absolute;
            right: 60px;
            display: flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;

            .box {
                width: 114px;
            }

            .size {
                margin-left: 10px;
                margin-right: 30px;
                font-size: 16px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                text-align: left;
                color: #2e2e2e;
                letter-spacing: 0px;
            }

            .el-button--primary {
                color: #ffffff;
                background-color: #262d33;
                border-color: #ffffff;
                font-family: "PingFang SC";

                :active {
                    opacity: 0.9; //这里重要，就是通过这个透明度来设置
                }
            }
        }
    }

    .el-aside {
        background-color: #262d33;
        width: 250px;

        img {
            margin-top: 20px;
            width: 60px;
            height: 60px;
        }

        .el-menu {
            border-right: none;

            //overflow: hidden;
            .el-menu-item i {
                //color: rgb(162, 184, 208);
                margin-right: 10px;
            }
        }
    }
</style>
